export default __webpack_public_path__ + "static/media/a011-05.ce38e40d.jpg";